<template lang="html">
    <section class="delete-count-down">
        <p>
            {{ $t("countdown.confirmdelete") }} <strong style="color: red;">"{{ action.data.name }}"</strong>
        </p>
        <button class="btn" @click.prevent="hideModal">{{ $t("countdown.btncancel") }}</button>
        <button type="submit" class="btn" @click.prevent="deleteThisCountDown(action);">{{ $t("countdown.btndelete") }}</button>
    </section>
</template>

<script lang="js">
import {mapActions} from 'vuex'
import httpService from '../../../../components/service'

export default {
    name: 'delete-count-down',
    props: [
        'action'
    ],
    mounted () {

    },
    data () {
        return {}
    },
    methods: {
        ...mapActions({
            listCountDown: 'countdown/listCountDown'
        }),
        deleteThisCountDown: function (value) {
            httpService.delete('/countdowns/' + value.data.id).then(response => {
                if (response === 'success') {
                    this.listCountDown()
                    this.$root.$emit('bv::hide::modal', 'defaultModal')
                } else {
                    console.error('...+ ERROR DeleteCountDown +....', response)
                }
            })
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {}
}
</script>

<style scoped lang="scss">
.delete-count-down {
}
</style>



// WEBPACK FOOTER //
// DeleteCountDown.vue?51d36c09